import * as React from "react";

export const IconDownloadTemplate = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_46251_10019)">
      <path
        d="M15.8337 7.5H12.5003V2.5L7.50033 2.5L7.50033 7.5L4.16699 7.5L10.0003 13.3333L15.8337 7.5ZM4.16699 15L4.16699 16.6667H15.8337V15L4.16699 15Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_46251_10019">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
